import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHelmet } from '@agro-club/frontend-shared'

import * as Layout from 'views/layouts/MainLayout/MainLayout'

import InventoryTransactionList from './InventoryTransactionList'
import InventoryHeader from '../InventoryHeader'

const InventoryTransactionTable: React.FC = () => {
  const { t } = useTranslation('inventoryTransaction')

  useHelmet({ title: t('inventoryTransactionMetaTitle') })

  return (
    <>
      <InventoryHeader activeTab="Transactions" />
      <Layout.Content>
        <InventoryTransactionList />
      </Layout.Content>
    </>
  )
}

export default InventoryTransactionTable
